import { render } from "./PorchMain.vue?vue&type=template&id=520938f2"
import script from "./PorchMain.vue?vue&type=script&lang=js"
export * from "./PorchMain.vue?vue&type=script&lang=js"
script.render = render

export default script